import Growth from 'src/assets/WereHiring/growth.avif'
import Perspective from 'src/assets/WereHiring/perspective.avif'
import Freedom from 'src/assets/WereHiring/freedom.avif'
import CompetitiveRemuneration from 'src/assets/WereHiring/CompetitiveRemuneration.avif'
import { useTranslations } from 'src/provider/LocaleProvider'
import { WereHiringProps } from "src/types";



export function WereHiringLabels() {
    const t = useTranslations()
    const WereHiringContent: WereHiringProps[] = [
        {
            id: 1,
            icon: Growth,
            title: t('worldWile.were.growth.title'),
            content: t('worldWile.were.growth.content'),
        },
        {
            id: 2,
            icon: Perspective,
            title: t('worldWile.were.perspective.title'),
            content: t('worldWile.were.perspective.content'),
        },
        {
            id: 3,
            icon: Freedom,
            title: t('worldWile.were.freedom.title'),
            content: t('worldWile.were.freedom.content'),
        },
        {
            id: 4,
            icon: CompetitiveRemuneration,
            title: t('worldWile.were.competitive.title'),
            content: t('worldWile.were.competitive.content'),
        },
    ]
    return { WereHiringContent }
}
